import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { Status } from '../../Status'

function EntityStatus({
  className,
  height,
  id,
  statuses,
  textClassName,
  textQaName,
}) {
  const { t } = useTranslation()

  const { text, ...restStatusProps } = statuses?.[id] ?? EMPTY_OBJECT

  return text ? (
    <Status
      {...restStatusProps}
      className={className}
      height={height}
      text={t(text)}
      textClassName={textClassName}
      textQaName={textQaName}
    />
  ) : null
}

export default EntityStatus
